import React, { Component } from "react";
import {
  DKLabel,
  DKButton,
  DKIcons,
  INPUT_TYPE,
  showAlert,
  DKIcon,
  DKListPicker,
  DKListPicker2,
  INPUT_VIEW_DIRECTION,
  showToast,
  TOAST_TYPE
} from "deskera-ui-library";
import {
  COLUMN_CODE,
  TableManger,
  TABLES,
} from "../../../managers/TableManger";
// import { PipelineManager } from "../../../managers/PipelineManager";
import {
  AUTOMATION_ACTIONS,
  AUTOMATION_ELEMENT,
  AUTOMATION_TRIGGERS,
  OPERATOR_LIST,
  SPLIT_ACTION_TYPE,
  SPLIT_CONSTANT,
} from "../AutomationConstants";
import ControlledInput from "../../common/ControlledInput";
import { isEqual } from "lodash";
import { PipelineManager } from "../../../managers/PipelineManager";
import { MULTIPLE_OF_05 } from "../../../constants/RegexConstants";
import EmployeeManager from "../../add-employee/steps/Employee";
import AutomationManager from "../AutomationManager";

export interface IFieldMapperProps {
  tableName: string;
  onClose: () => void;
  onSave: (field: any, logicalOperator: any) => void;
  stepData: any;
  isSingleCondition?: any;
  parentStepType?: any;
}
export interface IFieldMapperState {
  fields: any;
  operator: any;
  logicalOperator: any;
  showColumns: boolean;
  showOptions: boolean;
  loadingDealData: boolean;
}
export default class FieldMapper extends Component<
  IFieldMapperProps,
  IFieldMapperState
> {
  columns: any = {};
  isMapperInvalid: boolean = false;
  pipelineDetails = PipelineManager.processPipelineData();
  data =
    this.props.stepData &&
    this.props.stepData.configuration &&
    this.props.stepData.configuration.fields
      ? this.props.stepData.configuration.fields
      : null;

  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      logicalOperator:
        this.props.stepData && this.props.stepData.logicalOperator
          ? this.props.stepData.logicalOperator
          : "and",
      showColumns: false,
      showOptions: false,
      operator: {},
      loadingDealData: true,
    };
  }
  componentDidMount() {
    this.getData();
  }
  render() {
    return (
      <div className="transparent-background">
        <div
          className="popup-window"
          style={{ padding: 0, maxWidth: 500, overflow: "visible" }}
        >
          {this.renderHeader()}
          {this.renderBody()}
          {this.renderBottom()}
        </div>
      </div>
    );
  }
  renderHeader() {
    return (
      <div className="row justify-content-between pt-s pb-s bg-gray3 p-h-m">
        <DKLabel text={this.props.stepData.title} className="fw-m" />
        <DKButton
          icon={DKIcons.ic_close}
          onClick={() => this.props.onClose()}
        />
      </div>
    );
  }
  renderBody() {
    const title =
      this.props.stepData.elementType === AUTOMATION_ELEMENT.ACTION
        ? `Map the fields for... <i>${this.props.stepData.title}</i>`
        : "Map the conditions to trigger this automation...";
    return (
      <div className="column p-l parent-width">
        <DKLabel text={`${title} `} className="" />
        <div className="parent-width bg-white border-radius-s pb-m border-box mt-l">
          {this.props.tableName === TABLES.CONTACT || this.props.tableName === TABLES.EMPLOYEE_LIST &&
            Object.keys(this.state.fields).map((field) => {
              return (
                <FieldRow
                  elementType={this.props.stepData.elementType}
                  field={field}
                  columns={this.columns}
                  fields={this.state.fields}
                  onChange={this.onChange}
                  operator={this.state.operator[field]}
                  onConditionChange={(opr) =>
                    this.setState({
                      operator: { ...this.state.operator, [field]: opr },
                    })
                  }
                  onFieldRemove={() => this.onFieldRemove(field)}
                />
              );
            })}
          {this.props.tableName === TABLES.DEAL &&
            !this.state.loadingDealData && (
              <DealFieldRows
                columns={this.columns}
                fields={this.state.fields}
                onChange={this.onChange}
              />
            )}

          {this.props.tableName === TABLES.CANDIDATE &&
            Object.keys(this.state.fields).map((field) => {
              return (
                <FieldRow
                  elementType={this.props.stepData.elementType}
                  field={field}
                  columns={this.columns}
                  fields={this.state.fields}
                  onChange={this.onChange}
                  operator={this.state.operator[field]}
                  onConditionChange={(opr) =>
                    this.setState({
                      operator: { ...this.state.operator, [field]: opr },
                    })
                  }
                  onFieldRemove={() => this.onFieldRemove(field)}
                  type={this.props.stepData.type}
                  parentStepType={this.props.parentStepType}
                />
              );
            })
            }
        </div>
        {this.props.stepData.elementType === AUTOMATION_ELEMENT.TRIGGER && (this.props.tableName !== TABLES.DEAL) &&
          Object.keys(this.state.fields).length > 1 &&
          this.getLogicalOperatorButtons()}
        {this.props.tableName !== TABLES.DEAL && Object.keys(this.columns).length !==
          Object.keys(this.state.fields).length && (
          <>{this.props.stepData?.type !=AUTOMATION_ACTIONS.CALCULATE_COMMISSION &&<DKButton
            title={
              this.props.stepData.elementType === AUTOMATION_ELEMENT.ACTION
                ? "+ Add Row"
                : "+ Add another condition"
            }
            className="text-blue fw-m mt-xs"
            onClick={() => this.addNewRandomField()}
          />}</>
        )}
      </div>
    );
  }
  renderBottom() {
    return (
      <div className="row-reverse pb-l p-h-m">
        <DKButton
          title="Save"
          className="bg-button text-white ml-m"
          onClick={() => this.save()}
        />

        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={() => this.props.onClose()}
        />
      </div>
    );
  }
  getLogicalOperatorButtons() {
    return (
      <div
        className="bg-white align-self-center border-m shadow-s-2 border-radius-s row width-auto mt-s"
        style={{ overflow: "hidden" }}
      >
        <div
          className="cursor-hand"
          onClick={() => {
            this.setState({ logicalOperator: "and" });
          }}
        >
          <DKLabel
            text="And"
            className={
              "p-v-xs p-h-s  " +
              (this.state.logicalOperator === "and"
                ? "bg-gray1 fw-m"
                : "text-gray")
            }
          />
        </div>
        <div
          className="cursor-hand"
          onClick={() => {
            this.setState({ logicalOperator: "or" });
          }}
        >
          <DKLabel
            text="Or"
            className={
              "p-v-xs p-h-s  " +
              (this.state.logicalOperator === "or"
                ? "bg-gray1 fw-m"
                : "text-gray")
            }
          />
        </div>
      </div>
    );
  }
  save() {
    if(this.isMapperInvalid) {
      showToast(
        "Please fill the details",
        TOAST_TYPE.FAILURE
    );
      return;
    }
    let fieldsInVaild = false;
    let fieldsData = [];
    Object.keys(this.state.fields).forEach((key) => {
      if(!this.state.fields[key]){
        fieldsInVaild = true;
        this.isMapperInvalid = true;
      }
      fieldsData.push({
        [key]: this.columns[key].options?.length
          ? [this.state.fields[key]]
          : this.state.fields[key],
        opr: this.state.operator[key] ? this.state.operator[key] : "eq",
      });
    });
    if(!fieldsInVaild) {
      this.isMapperInvalid = false
      this.props.onSave(fieldsData, this.state.logicalOperator);
    } else {
      this.isMapperInvalid = true;
      showToast(
        "Please fill the details",
        TOAST_TYPE.FAILURE
    );
    }
    
  }
  getData() {
    let columns = TableManger.getTableColumns(this.props.tableName).filter(
      this.getColumnFilterFunc()
    );
    if(this.props.tableName === TABLES.CANDIDATE) {
      this.columns = {
        flatAmount: {
          id: "flatAmount",
          key: "flatAmount",
          value: "flatAmount",
          name: SPLIT_CONSTANT.flatAmount,
          type: 'number',
          splitConfigType: SPLIT_ACTION_TYPE.COMMISSION_BASED_ON,
        },
        percentageOfDealCost: {
          id: "percentageOfDealCost",
          key: "percentageOfDealCost",
          value: "percentageOfDealCost",
          name: SPLIT_CONSTANT.percentageOfDealCost,
          type: 'number',
          splitConfigType: SPLIT_ACTION_TYPE.COMMISSION_BASED_ON,
        }
      };
    } else if (this.props.tableName === TABLES.EMPLOYEE_LIST) {
      AutomationManager.filterEmployeeColumns().forEach((column) => {
        if (column.id === "reportingManagerId") {
          column.options = EmployeeManager.getReportingManagers();
        }

        this.columns[column.id] = column
      });
    } else {
      columns.forEach((column) => {
        if (this.props.tableName === TABLES.DEAL) {
          if (column.columnCode === COLUMN_CODE.DEAL.PIPELINE_ID) {
            column.name = "Pipeline";
            column.options = this.pipelineDetails;
          }
          if (column.columnCode === COLUMN_CODE.DEAL.STAGE_ID) {
            column.name = "Stage";
            column.options = this.pipelineDetails[0]?.stages;
          }
          // if (column.columnCode === COLUMN_CODE.DEAL.NAME) {
          //   column.name = "Name";
          //   column.options = [];
          // }
          if (
            column.columnCode === COLUMN_CODE.DEAL.ORGANIZATION_ID ||
            column.columnCode === COLUMN_CODE.DEAL.CONTACT_ID
          ) {
            return;
          }
        }
        this.columns[column.id] = column;
      });
    }
    
    this.setState({ loadingDealData: false });
    if (!this.data) {
      if (this.props.tableName === TABLES.DEAL) {
        this.addPipelineAndStage();
      } else {
        if (this.props.stepData.type !== AUTOMATION_TRIGGERS.CONTACT_ADDED)
          this.addNewRandomField();
      }
    } else {
      let fields = {};
      let operator = {};
      this.data.forEach((data) => {
        let key = Object.keys(data)[0];
        operator[key] = data.opr ? data.opr : "eq";
        let parsedData = {
          [key]:
            this.columns[key]?.options && this.columns[key]?.options.length
              ? data[key][0]
              : data[key],
        };
        fields = { ...fields, ...parsedData };
      });
      this.setState({ fields, operator });
    }
  }
  
  getColumnFilterFunc = () => {
    if (this.props.tableName === TABLES.CANDIDATE) {
      return (column) => {
        let returnVal = false;
        if (column.uiVisible && column.type !== INPUT_TYPE.DATE)
          returnVal = true;
        if (TableManger.isSelectField(column) && column.options.length === 0)
          returnVal = false;
        return returnVal;
      };
    } 
    else if (this.props.tableName === TABLES.DEAL) {
      return (column) => {
        
        return((column.type === INPUT_TYPE.SELECT ||
        column.type === INPUT_TYPE.MULTI_SELECT ||
        
        column.type === "ref")&& column.columnCode !== 'visibility') 
      };
    } 
    else {
      return (column) =>
        column.type === INPUT_TYPE.SELECT ||
        column.type === INPUT_TYPE.MULTI_SELECT ||
        column.type === "ref";
    }
  };
  addField(column) {
    let fields = { ...this.state.fields };
    if (TableManger.isSelectField(column) && column.options[0]) {
      fields[column.id] = column.options[0].id
    } else {
      fields[column.id] = "";
    }

    this.setState({
      fields,
    });
  }
  addNewRandomField() {
    let allAddedFields = Object.keys(this.state.fields);
    for (let key of Object.keys(this.columns)) {
      if (!allAddedFields.includes(key)) {
        this.addField(this.columns[key]);
        return;
      }
    }
  }
  addPipelineAndStage() {
    const pipelineColumnID = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.PIPELINE_ID
    );
    const stageColumnID = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.STAGE_ID
    );
    const visibilityColumnID = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.VISIBILITY
    );
    // const dealName = TableManger.getColumnId(
    //   TABLES.DEAL,
    //   COLUMN_CODE.DEAL.NAME
    // );
    let fields = { ...this.state.fields };
    const pipeline = this.columns[pipelineColumnID];
    fields[pipelineColumnID] = pipeline.options[0]?.id;
    fields[stageColumnID] = pipeline.options[0]?.stages[0]?.id;
    // fields[visibilityColumnID] = this.columns[visibilityColumnID].options[0]?.id;
    // fields[dealName] = this.columns[dealName]?.id
    this.setState({
      fields,
    });
  }
  onChange = (newField, oldField,isMapperInvalid) => {
    this.isMapperInvalid = isMapperInvalid;
    let fields = { ...this.state.fields };
    let newKey = Object.keys(newField)[0];
    if (oldField) {
      fields = this.reorderFields(fields, oldField, newKey, newField[newKey]);
    } else {
      fields[newKey] = newField[newKey];
    }
    this.setState({ fields });
  };
  onFieldRemove = (field) => {
    let fields = { ...this.state.fields };
    if (
      Object.keys(fields).length === 1 &&
      this.props.stepData.elementType === AUTOMATION_ELEMENT.ACTION
    ) {
      showAlert("Can't delete", "You should at-least have one mapping field.");
    } else {
      delete fields[field];
      this.setState({ fields });
    }
  };
  reorderFields(fields, oldKey, newKey, newValue) {
    let newFields = {};
    const keys = Object.keys(fields);
    keys.forEach((key) => {
      if (key === oldKey) {
        newFields[newKey] = newValue;
      } else {
        newFields[key] = fields[key];
      }
    });
    return newFields;
  }
}

export class FieldRow extends Component<any, any> {
  isMapperInvalid: boolean = false;
  errorMessage = null
  constructor(props) {
    super(props);
    this.state = {
      showColumns: false,
      showOptions: false,
      needConditionPicker: false,
      operator: this.props.operator,
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(this.props, prevProps)) {
      this.setState({ operator: this.props.operator });
    }
  }
  hideUnHideColumns = (flag = null) => {
    if (flag === null) flag = !this.state.showColumns;
    this.setState({ showColumns: flag });
  };
  hideUnHideOptions = (flag = null) => {
    if (flag === null) flag = !this.state.showOptions;
    this.setState({ showOptions: flag });
  };
  isInvalid(field) {
    let isInvalid = false;
    if(field == 'percentageOfDealCost' && this.props.columns && this.props.columns[field]?.type === 'number') {
      let value = this.props.fields[this.props.field];
      if(value && value>=0 && value<=100) {
        isInvalid = false;
      } else {
        isInvalid = true;
      }
    }
    return isInvalid;
  }
  render() {
    return (
      <div className="row justify-content-between mt-m ">
        <div
          className="bg-gray1 row p-h-m fs-m border-radius-m border-m mr-r cursor-hand position-relative justify-content-between"
          style={{ height: 37 }}
        >
          <div
            className="parent-width parent-height position-absolute"
            style={{ top: 0, left: 0 }}
            onClick={() => this.hideUnHideColumns()}
          />
          <DKLabel
            text={this.props.columns[this.props.field]?.name}
            className=""
          />
          <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s ml-s" />
          {this.state.showColumns && (
            <DKListPicker
              className={`${this.props.isFieldAlign ? "list-picker-popup":"position-absolute"} position-absolute shadow-m border-m z-index-1 parent-width`} 
              data={Object.keys(this.props.columns).map(
                (column) => this.props.columns[column].name
              )}
              onClose={() => {
                this.hideUnHideColumns(false);
              }}
              onSelect={(index, value) => {
                this.onColumnChange(index);
                this.hideUnHideColumns();
              }}
            />
          )}
        </div>
        {!this.props.isSingleCondition && <>
        {this.getConditionSelection()}
        {this.props.columns[this.props.field] && 
        this.props.columns[this.props.field].type !== INPUT_TYPE.SELECT &&
        this.props.columns[this.props.field].type !== INPUT_TYPE.MULTI_SELECT &&
        this.props.columns[this.props.field].type !== "ref" ? (
          <div
            className={`bg-gray1 row fs-m border-radius-m ml-r cursor-hand position-relative justify-content-between parent-width ${!this.isMapperInvalid ? "border-m":" mt-l " }` }
            style={{ overflow: "hidden" }}
          >
            <ControlledInput
              
              className="bg-white"
              direction={INPUT_VIEW_DIRECTION.VERTICAL}
              autoFocus={true}
              value={this.props.fields[this.props.field]}
              placeHolder={"Enter value"}
              readOnly={this.props.readOnly}
              required={this.props.columns[this.props.field]?.required ? this.props.columns[this.props.field].required: null}
              type={this.props.columns[this.props.field]?.type ? this.props.columns[this.props.field].type:'text'}
              invalid={this.isMapperInvalid}
              suffixSymbol={this.props.field=="percentageOfDealCost" ? "%":null}
              onChange={(e) => {
                this.onOptionChange(-1, e.target.value)
              }}
              errorMessage={this.errorMessage}
            />
            
          </div>
        ) : (
          <div
            className="bg-gray1 row fs-m border-radius-m border-m ml-r cursor-hand position-relative justify-content-between"
            style={{ height: 37 }}
          >
            <div
              className=" parent-width parent-height position-absolute"
              style={{ top: 0, left: 0 }}
              onClick={() => this.hideUnHideOptions()}
            />
            <DKLabel
              text={
                this.props.columns[this.props.field]?.options.find(
                  (option) => option.id === this.props.fields[this.props.field]
                ).name
              }
              className="pl-s"
            />
            <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s ml-s pr-s" />
            {this.state.showOptions && (
              <div className="position-absolute shadow-m border-m z-index-1 parent-width">
                <DKListPicker2
                  className=""
                  height={200}
                  data={this.props.columns[this.props.field]?.options.map(
                    (option) => option.name
                  )}
                  onClose={() => {
                    this.hideUnHideOptions(false);
                  }}
                  onSelect={(index, value) => {
                    this.onOptionChange(index);
                    this.hideUnHideOptions();
                  }}
                />
              </div>
            )}
          </div>
        )}
        </>}
        {Object.keys(this.props.fields).length > 0 && (
          <DKButton
            icon={DKIcons.ic_delete}
            style={{ paddingRight: 0 }}
            onClick={() => this.props.onFieldRemove()}
          />
        )}
      </div>
    );
  }
  onOptionChange(index, value = "") {
    this.errorMessage = null
    let field = this.props.field;
    let newOption =
      index !== -1
        ? this.props.columns[this.props.field].options[index].id
        : value;
        
        if(field == 'percentageOfDealCost' && this.props.columns && this.props.columns[field]?.type === 'number') {
          let valueInt = parseFloat(value);
          if(  (valueInt && valueInt>=0 && valueInt<=100)) {
            this.isMapperInvalid = false;
          } else {
            this.isMapperInvalid = true;
          }
        }
        if(this.props.columns && this.props.columns[field]?.type === 'number' && value===""){
          this.isMapperInvalid = true;
        } else if(this.props.type === AUTOMATION_ACTIONS.LEAVE_APPROVAL && !new RegExp(MULTIPLE_OF_05).test(value)) {
          this.isMapperInvalid = true
          this.errorMessage = 'Leave days should be multiple of 0.5'
        } else if(field != 'percentageOfDealCost' && this.props.columns && this.props.columns[field]?.type === 'number' && value!=="" && parseFloat(value) > -1){
          this.isMapperInvalid = false;
        } else if(field != 'percentageOfDealCost' && this.props.columns && this.props.columns[field]?.type === 'number' && value!=="" && (parseFloat(value) < 0 || value.includes('-'))){
          this.isMapperInvalid = true;
        }
        this.setState({
          ...this.state
        })

    this.props.onChange({ [this.props.field]: newOption }, null,this.isMapperInvalid);
  }
  onColumnChange(index) {
    let newColumn = Object.keys(this.props.columns)[index];
    const column = this.props.columns[newColumn];
    if (newColumn === this.props.field) return;
    this.props.onChange(
      {
        [newColumn]: TableManger.isSelectField(column)
          ? column.options[0].id
          : "",
        type: column.name || ""
      },
      this.props.field
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  getOperatorList() {
    const columnType = this.props.columns[this.props.field].type;
    const { EQUAL, CONTAINS, GREATER, LESSER,GREATER_EQUAL, LESSER_EQUAL } = OPERATOR_LIST;
    switch (columnType) {
      case INPUT_TYPE.NUMBER:
        return [EQUAL, GREATER, LESSER, GREATER_EQUAL, LESSER_EQUAL].map((operator) => operator.displayName);
      default:
        return [EQUAL, CONTAINS].map((operator) => operator.displayName);
    }
  }

  getOperatorSymbol(token) {
    const filteredOperatorKey = Object.keys(OPERATOR_LIST).find(
      (operatorKey) => OPERATOR_LIST[operatorKey].token === token
    );
    const filteredOperator = OPERATOR_LIST[filteredOperatorKey];
    return filteredOperator?.symbol || OPERATOR_LIST.EQUAL.symbol;
  }

  getOperatorToken(operatorText) {
    const filteredOperatorKey = Object.keys(OPERATOR_LIST).find(
      (operatorKey) => OPERATOR_LIST[operatorKey].displayName === operatorText
    );
    const filteredOperator = OPERATOR_LIST[filteredOperatorKey];
    return filteredOperator?.token || OPERATOR_LIST.EQUAL.token;
  }

  getConditionSelection() {
    return (
      <div className="cursor-hand position-relative">
        <div
          onClick={() => {
            if (this.props.elementType === AUTOMATION_ELEMENT.TRIGGER || this.props.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW
              || this.props.type === AUTOMATION_ACTIONS.EXPENSE_APPROVAL) {
                this.setVisibilityOfConditionPicker(true);
            }
          }}
        >
          <DKLabel text={this.getOperatorSymbol(this.state.operator || "eq")} />
        </div>
        {this.state.needConditionPicker && (
          <DKListPicker
            className="position-absolute border-m shadow-s-2 border-radius-s z-index-2"
            style={{ top: 10, left: 10, width:'max-content' }}
            data={this.getOperatorList()}
            onSelect={(index, displayName) => {
              this.setVisibilityOfConditionPicker(false);
              let opr = this.getOperatorToken(displayName);
              this.props.onConditionChange(opr);
            }}
            width={120}
            onClose={() => this.setVisibilityOfConditionPicker(false)}
          />
        )}
      </div>
    );
  }
  setVisibilityOfConditionPicker = (visible) => {
    this.setState({ needConditionPicker: visible });
  };

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
}

export class DealFieldRows extends Component<any, any> {
  pipelineColumnID;
  stageColumnID;
  visibilityColumnID;
  columns;
  constructor(props) {
    super(props);
    this.state = {
      showPipeline: false,
      fields: {},
      showStage: false,
      showVisibility: false,
      columns: props.columns,
    };
    this.pipelineColumnID = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.PIPELINE_ID
    );
    this.stageColumnID = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.STAGE_ID
    );
    // this.visibilityColumnID = TableManger.getColumnId(
    //   TABLES.DEAL,
    //   COLUMN_CODE.DEAL.VISIBILITY
    // );
  }
  componentDidMount() {
    this.setData();
  }
  render() {
    let pipelineData = [];
    if (Array.isArray(this.state.columns[this.pipelineColumnID]?.options)) {
      pipelineData = this.state.columns[this.pipelineColumnID].options.map(
        (option) => option.name
      );
    }

    let stageData = [];
    if (Array.isArray(this.state.columns[this.stageColumnID]?.options)) {
      stageData = this.state.columns[this.stageColumnID].options.map(
        (option) => option.name
      );
    }

    return (
      <>
        <div className="row justify-content-between mt-m ">
          <DKLabel text={"Pipeline"} className="" style={{ minWidth: "40%" }} />
          <div
            className="bg-white row p-h-m fs-m border-radius-m border-m ml-m cursor-hand position-relative justify-content-between"
            style={{ height: 32 }}
          >
            <div
              className=" parent-width parent-height position-absolute"
              style={{ top: 0, left: 0 }}
              onClick={() => this.hideUnHidePipeline()}
            />
            <DKLabel
              text={this.state.fields[this.pipelineColumnID]?.name}
              className=""
            />
            <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s ml-s" />
            {this.state.showPipeline && (
              <div
                className="position-absolute shadow-m border-m z-index-1"
                style={{ width: "100%" }}
              >
                <DKListPicker
                  className=""
                  height={200}
                  data={pipelineData}
                  onClose={() => this.hideUnHidePipeline()}
                  onSelect={(index, value) => {
                    this.onChange(
                      this.pipelineColumnID,
                      this.state.columns[this.pipelineColumnID].options[index]
                    );
                    this.hideUnHidePipeline();
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="row justify-content-between mt-m ">
          <DKLabel text={"Stage"} style={{ minWidth: "40%" }} />
          <div
            className="bg-white row p-h-m fs-m border-radius-m border-m ml-m cursor-hand position-relative justify-content-between"
            style={{ height: 32 }}
          >
            <div
              className=" parent-width parent-height position-absolute"
              style={{ top: 0, left: 0 }}
              onClick={() => this.hideUnHideStage()}
            />
            <DKLabel
              text={this.state.fields[this.stageColumnID]?.name}
              className="parent-width"
            />
            <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s ml-s" />
            {this.state.showStage && (
              <div
                className="position-absolute shadow-m border-m z-index-1"
                style={{ width: "100%" }}
              >
                <DKListPicker
                  className=""
                  height={200}
                  data={stageData}
                  onClose={() => this.hideUnHideStage()}
                  onSelect={(index, value) => {
                    this.onChange(
                      this.stageColumnID,
                      this.state.columns[this.stageColumnID].options[index]
                    );
                    this.hideUnHideStage();
                  }}
                />
              </div>
            )}
          </div>
        </div>

        {this.visibilityColumnID && <div className="row justify-content-between mt-m ">
          <DKLabel text={"Visibility"} style={{ minWidth: "40%" }} />
          <div
            className="bg-white row p-h-m fs-m border-radius-m border-m ml-m cursor-hand position-relative justify-content-between"
            style={{ height: 32 }}
            onClick={() => this.hideUnHideVisibility()}
          >
            <DKLabel
              text={this.state.fields[this.visibilityColumnID]?.name}
              className=""
            />
            <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s ml-s" />
            {this.state.showVisibility && (
              <div
                className="position-absolute shadow-m border-m z-index-1"
                style={{ width: "100%" }}
              >
                <DKListPicker
                  className=""
                  height={200}
                  data={this.state.columns[this.visibilityColumnID].options.map(
                    (option) => option.name
                  )}
                  onClose={() => this.hideUnHideVisibility()}
                  onSelect={(index, value) =>
                    this.onChange(
                      this.visibilityColumnID,
                      this.state.columns[this.visibilityColumnID].options[index]
                    )
                  }
                />
              </div>
            )}
          </div>
        </div>}
      </>
    );
  }
  hideUnHidePipeline = (flag = null) => {
    if (flag === null) flag = !this.state.showPipeline;
    this.setState({ showPipeline: flag });
  };
  hideUnHideStage = (flag = null) => {
    if (flag === null) flag = !this.state.showStage;
    this.setState({ showStage: flag });
  };
  hideUnHideVisibility = (flag = null) => {
    if (flag === null) flag = !this.state.showVisibility;
    this.setState({ showVisibility: flag });
  };
  onChange(colId, value) {
    let fields = { ...this.state.fields };
    let columns = { ...this.state.columns };
    fields[colId] = value;
    if (colId === this.pipelineColumnID) {
      columns[this.stageColumnID].options = value.stages;
      fields[this.stageColumnID] = value.stages[0];
      this.props.onChange({ [this.stageColumnID]: value.stages[0].id });
    }
    this.setState({ fields }, () => {
      this.props.onChange({ [colId]: value.id });
    });
  }
  setData() {
    let fields = {};
    let columns = { ...this.state.columns };
    fields[this.pipelineColumnID] = this.props.fields[this.pipelineColumnID]
      ? this.state.columns[this.pipelineColumnID].options.find(
          (data) => data.id === this.props.fields[this.pipelineColumnID]
        )
      : (this.state.columns[this.pipelineColumnID].options?this.state.columns[this.pipelineColumnID].options[0]:null);
    fields[this.stageColumnID] = this.props.fields[this.stageColumnID]
      ? fields[this.pipelineColumnID].stages.find(
          (data) => data.id === this.props.fields[this.stageColumnID]
        )
      : (this.state.columns[this.stageColumnID].options? this.state.columns[this.stageColumnID].options[0]:{});
    // fields[this.visibilityColumnID] = this.props.fields[this.visibilityColumnID]
    //   ? this.state.columns[this.visibilityColumnID].options.find(
    //       (data) => data.id === this.props.fields[this.visibilityColumnID]
    //     )
    //   : (this.state.columns[this.visibilityColumnID].options ? this.state.columns[this.visibilityColumnID].options[0]:{});
    columns[this.stageColumnID].options = fields[this.pipelineColumnID]?.stages;
    this.setState({ fields, columns });
  }
}
